import React, { useState, useRef, useEffect } from "react"

//
// inputs
// - urls:
//   {
//     "LABEL": "URL",
//     ...
//   }
// - label: button label (default: "Export")
// - primary: whether to use primary button style (default: true)
//
export default function ExportDropdown({urls, label = "Export", primary = true}) {
  const [show, setShow] = useState(false)
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const buttonClass = primary ? "button button__primary" : "button";

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} ref={dropdownRef}>
      <button onClick={() => setShow(!show)} className={buttonClass}>
        {label}&nbsp;
        <svg width="10" height="6" viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg" style={{display: "inline", verticalAlign: "middle"}}>
          <path d="M0 0 L5 6 L10 0 Z" fill="currentColor"/>
        </svg>
      </button>
      <div className={`${show ? "block" : "hidden"} absolute z-10 right-0 bg-white border border-gray-200 rounded-lg shadow-lg mt-2 p-2 w-48`} style={{ position: 'absolute', zIndex: 1 }}>
        <div className=" ">
          {Object.entries(urls).map(([label, url]) => (
            <a key={label} href={url} className="block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => setShow(false)} data-turbo="false">
              {label}
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
